export const authFetch = (url, options = {}) => {
    return fetch(url, {
        ...options,
        credentials: "include", // 🔥 THIS is the key
        headers: {
            "Content-Type": "application/json",
            ...(options.headers || {}),
        },
    });
};